import {useState} from 'react'
import {loadCrmSnapshot} from './api'
import {useCrmIdentity} from './crmIdentity'
import {currentCrmReadSignal,crmReadOwnerCurrent,type CrmPermissionContext} from './crmSync'
import type {CrmDataSnapshot} from './runtimeState'

type MembershipProof={context:CrmPermissionContext;epoch:number;owner:AbortSignal}

export function useCompanyQueueStartup(){
  const identity=useCrmIdentity()
  const identityKey=JSON.stringify([identity.userId,identity.workspaceId,identity.role,[...identity.capabilities].sort()])
  const [proof,setProof]=useState<MembershipProof|null>(null)
  const readSnapshot=async(previous:CrmDataSnapshot|undefined,context:CrmPermissionContext)=>{
    const owner=currentCrmReadSignal(),epoch=context.readEpoch
    setProof(null)
    const snapshot=await loadCrmSnapshot(previous,membership=>{
      if(membership.canonicalRole===identity.role&&context.key===identityKey&&context.active&&context.readEpoch===epoch&&owner&&crmReadOwnerCurrent(owner)){setProof({context,epoch,owner})}
    })
    if(snapshot.canonicalRole!==identity.role)throw new Error('canonical_role_mismatch')
    return snapshot
  }
  // Match WorkQueueView's actual-identity predicate, including task-only Ops.
  // Role previews cannot grant a read or change its permission context.
  const allowed=identity.capabilities.includes('sales.read')||identity.role==='OPERATIONS_ADMIN'&&identity.capabilities.includes('prospect.work.handle')
  const ready=(context:CrmPermissionContext|undefined)=>Boolean(allowed&&proof&&proof.context===context&&context.key===identityKey&&context.active&&context.readEpoch===proof.epoch&&crmReadOwnerCurrent(proof.owner))
  return{readSnapshot,ready}
}
